(function () {
  "use strict";
  var sc = document.getElementById("mdl-scroll"),
    bl = document.getElementById("mdl-left"),
    br = document.getElementById("mdl-right"),
    blm = document.getElementById("mdl-left-m"),
    brm = document.getElementById("mdl-right-m");

  /* Dynamic scroll distance — R14: Rect+ScrollWidth+ClientWidth gecacht, rAF-throttle */
  var _mdlStepCache = null,
    _mdlMaxCache = null;
  function invalidateMdlStep() {
    _mdlStepCache = null;
    _mdlMaxCache = null;
  }
  window.addEventListener("resize", invalidateMdlStep, { passive: true });
  function getScrollStep() {
    if (_mdlStepCache != null) return _mdlStepCache;
    if (!sc) {
      _mdlStepCache = 300;
      return 300;
    }
    var firstCard = sc.querySelector(".mdl__card");
    if (firstCard) {
      var rect = firstCard.getBoundingClientRect();
      _mdlStepCache = rect.width + 16;
      return _mdlStepCache;
    }
    _mdlStepCache = sc.clientWidth * 0.85;
    return _mdlStepCache;
  }
  function getMdlMax() {
    if (_mdlMaxCache != null) return _mdlMaxCache;
    if (!sc) {
      _mdlMaxCache = 0;
      return 0;
    }
    _mdlMaxCache = sc.scrollWidth - sc.clientWidth;
    return _mdlMaxCache;
  }
  var _mdlScrollRAF = null;
  function checkScroll() {
    if (!sc || _mdlScrollRAF) return;
    _mdlScrollRAF = requestAnimationFrame(function () {
      _mdlScrollRAF = null;
      var sl = sc.scrollLeft,
        max = getMdlMax();
      var atStart = sl < 10,
        atEnd = sl >= max - 10;
      if (bl) bl.disabled = atStart;
      if (br) br.disabled = atEnd;
      if (blm) blm.disabled = atStart;
      if (brm) brm.disabled = atEnd;
    });
  }
  function scrollLeftFn() {
    if (!sc) return;
    sc.scrollBy({ left: -getScrollStep(), behavior: "smooth" });
    setTimeout(checkScroll, 400);
  }
  function scrollRightFn() {
    if (!sc) return;
    sc.scrollBy({ left: getScrollStep(), behavior: "smooth" });
    setTimeout(checkScroll, 400);
  }
  if (sc) {
    sc.addEventListener("scroll", checkScroll, { passive: true });
    /* Initial state: defer to idle time to avoid forced reflow on critical path */
    if ("requestIdleCallback" in window) {
      requestIdleCallback(checkScroll, { timeout: 1500 });
    } else {
      setTimeout(checkScroll, 300);
    }
  }
  if (bl) bl.addEventListener("click", scrollLeftFn);
  if (br) br.addEventListener("click", scrollRightFn);
  if (blm) blm.addEventListener("click", scrollLeftFn);
  if (brm) brm.addEventListener("click", scrollRightFn);

  var cards = document.querySelectorAll(".mdl__card[data-hue]");
  var _mdlCardId = 0;
  /* Assign unique per-card ID for shader key isolation */
  cards.forEach(function (c) {
    c.dataset.mdlId = _mdlCardId++;
  });

  var prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  /* Stagger reveal (vercel-react: single observer) */
  if (prefersReduced) {
    cards.forEach(function (c) {
      c.classList.add("is-visible");
    });
  } else if ("IntersectionObserver" in window) {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            setTimeout(
              function () {
                e.target.classList.add("is-visible");
              },
              Array.prototype.indexOf.call(cards, e.target) * 60,
            );
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -30px 0px" },
    );
    cards.forEach(function (c) {
      obs.observe(c);
    });
  } else {
    cards.forEach(function (c) {
      c.classList.add("is-visible");
    });
  }

  /* Three.js shader — IDENTICAL */
  var FS = [
    "precision mediump float;",
    "uniform vec2 u_resolution;uniform float u_time;uniform float u_hue;",
    "vec3 hsv2rgb(vec3 c){vec4 K=vec4(1.0,2.0/3.0,1.0/3.0,3.0);vec3 p=abs(fract(c.xxx+K.xyz)*6.0-K.www);return c.z*mix(K.xxx,clamp(p-K.xxx,0.0,1.0),c.y);}",
    "float rnd(vec2 st){return fract(sin(dot(st,vec2(12.9898,78.233)))*43758.5453);}",
    "float ns(vec2 st){vec2 i=floor(st);vec2 f=fract(st);vec2 u=f*f*(3.0-2.0*f);return mix(mix(rnd(i),rnd(i+vec2(1,0)),u.x),mix(rnd(i+vec2(0,1)),rnd(i+vec2(1,1)),u.x),u.y);}",
    "float fbm(vec2 st){float v=0.0;float a=0.5;for(int i=0;i<6;i++){v+=a*ns(st);st*=2.0;a*=0.5;}return v;}",
    "mat2 rot(float a){return mat2(cos(a),-sin(a),sin(a),cos(a));}",
    "void main(){",
    "vec2 uv=(gl_FragCoord.xy*2.0-u_resolution.xy)/min(u_resolution.x,u_resolution.y);",
    "float t=u_time;vec2 p=uv*rot(t*0.15);",
    "float n1=fbm(p*1.2+vec2(t*0.12,t*0.22));",
    "float n2=fbm(p*2.0+n1+vec2(-t*0.28,t*0.18));",
    "float n3=fbm(p*3.2+n2+vec2(t*0.12,-t*0.22));",
    "float fn=n1*0.6+n2*0.25+n3*0.15;",
    "float s=0.65+fn*0.35;float v=0.12+pow(fn,2.2)*1.8;v+=pow(smoothstep(0.65,1.0,fn),2.5)*1.2;",
    "vec3 col=hsv2rgb(vec3(u_hue/360.0+fn*0.12,s,v));",
    "col*=1.0-smoothstep(0.5,1.4,length(uv));",
    "float alpha=smoothstep(0.02,0.15,length(col))*0.85;",
    "gl_FragColor=vec4(col,alpha);}",
  ].join("\n");
  var VS = "void main(){gl_Position=vec4(position,1.0);}";
  var active = {},
    leaveTimers = {},
    ticking = {},
    _mdlFailed = {};

  /* Shader safety helpers */
  function hasWebGLSupport() {
    try {
      var c = document.createElement("canvas");
      return !!(
        window.WebGLRenderingContext &&
        (c.getContext("webgl") || c.getContext("experimental-webgl"))
      );
    } catch (e) {
      return false;
    }
  }
  function validShaderSource(src) {
    return typeof src === "string" && src.trim().length > 0;
  }
  function cleanupShader(inst) {
    if (!inst) return;
    try {
      cancelAnimationFrame(inst.frameId);
    } catch (e) {}
    try {
      if (inst.geometry) inst.geometry.dispose();
    } catch (e) {}
    try {
      if (inst.material) inst.material.dispose();
    } catch (e) {}
    try {
      if (inst.renderer) inst.renderer.dispose();
    } catch (e) {}
    try {
      if (
        inst.mount &&
        inst.renderer &&
        inst.renderer.domElement &&
        inst.mount.contains(inst.renderer.domElement)
      )
        inst.mount.removeChild(inst.renderer.domElement);
    } catch (e) {}
  }
  function enableShaderFallback(card, mount) {
    if (card) card.classList.add("evm--shader-fallback");
    if (mount) mount.classList.add("is-fallback");
  }

  function createShader(card) {
    var key =
      "mdl-c" + (card.dataset.mdlId || card.getAttribute("data-hue") || "0");
    if (_mdlFailed[key]) return null;
    var mount = card.querySelector(".mdl__shader");
    if (!mount || typeof THREE === "undefined") {
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    if (!hasWebGLSupport()) {
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    if (!validShaderSource(VS) || !validShaderSource(FS)) {
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var w = mount.clientWidth || 200,
      h = mount.clientHeight || 260;
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true });
    } catch (e) {
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    if (!renderer) {
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    try {
      /* Clear any leftover DOM children (old canvas from previous hover) */
      mount.innerHTML = "";
      renderer.setPixelRatio(1);
      renderer.setSize(Math.round(w * 0.5), Math.round(h * 0.5), false);
      renderer.domElement.style.width = "100%";
      renderer.domElement.style.height = "100%";
      mount.appendChild(renderer.domElement);
    } catch (e) {
      try {
        renderer.dispose();
      } catch (ex) {}
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var scene, cam, uni, geo, mat, mesh;
    try {
      scene = new THREE.Scene();
      cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
      var hue = parseFloat(card.getAttribute("data-hue")) || 263;
      uni = {
        u_time: { value: 0 },
        u_resolution: { value: new THREE.Vector2(w * 0.5, h * 0.5) },
        u_hue: { value: hue },
      };
      geo = new THREE.PlaneGeometry(2, 2);
      mat = new THREE.ShaderMaterial({
        uniforms: uni,
        vertexShader: VS,
        fragmentShader: FS,
        transparent: true,
      });
      mesh = new THREE.Mesh(geo, mat);
      scene.add(mesh);
    } catch (e) {
      try {
        if (geo) geo.dispose();
      } catch (ex) {}
      try {
        if (mat) mat.dispose();
      } catch (ex) {}
      try {
        if (renderer) renderer.dispose();
      } catch (ex) {}
      try {
        if (
          mount &&
          renderer &&
          renderer.domElement &&
          mount.contains(renderer.domElement)
        )
          mount.removeChild(renderer.domElement);
      } catch (ex) {}
      _mdlFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var start = performance.now(),
      fid = 0;
    function animate() {
      fid = requestAnimationFrame(animate);
      uni.u_time.value = (performance.now() - start) / 1000;
      try {
        renderer.render(scene, cam);
      } catch (e) {
        cancelAnimationFrame(fid);
        cleanupShader({
          frameId: fid,
          geometry: geo,
          material: mat,
          renderer: renderer,
          mount: mount,
        });
        _mdlFailed[key] = true;
        enableShaderFallback(card, mount);
        fid = 0;
      }
    }
    animate();
    return {
      renderer: renderer,
      material: mat,
      geometry: geo,
      frameId: fid,
      mount: mount,
    };
  }

  /* Cleanup: stop RAF loop, remove canvas, dispose GPU resources */
  function destroyShader(d) {
    if (!d) return;
    cancelAnimationFrame(d.frameId);
    if (d.mount && d.renderer && d.mount.contains(d.renderer.domElement))
      d.mount.removeChild(d.renderer.domElement);
    if (d.geometry) d.geometry.dispose();
    if (d.material) d.material.dispose();
    if (d.renderer) {
      d.renderer.dispose();
    }
  }

  /* R20.16: Fake-Stern-Injection entfernt (UWG-Compliance). Cards ohne Sterne, bis echte Bewertungen vorliegen. */

  /* Skip shader setup if reduced motion */
  if (prefersReduced) return;

  /* R18: Shared rect cache — invalidate on scroll/resize → zero forced reflow in mousemove */
  var _rectCache = {};
  var _invalidate = function () {
    _rectCache = {};
  };
  window.addEventListener("scroll", _invalidate, { passive: true });
  window.addEventListener("resize", _invalidate, { passive: true });

  cards.forEach(function (card) {
    var inner = card.querySelector(".mdl__card-inner");
    var glass = card.querySelector(".mdl__glass");
    var img = card.querySelector(".mdl__img");
    var shaderEl = card.querySelector(".mdl__shader");
    var key = "mdl-c" + (card.dataset.mdlId || "0");
    var hoverToken = 0;

    card.addEventListener("mouseenter", function () {
      hoverToken += 1;
      var thisHover = hoverToken;

      var color = card.getAttribute("data-color") || "#8B5CF6";
      var hue = card.getAttribute("data-hue") || "263";
      card.style.setProperty("--mdl-card-color", color);
      card.style.setProperty("--mdl-card-hue", hue);
      /* Cancel pending destroy so shader isn't killed mid-animation */
      if (leaveTimers[key]) {
        clearTimeout(leaveTimers[key]);
        leaveTimers[key] = null;
      }
      /* Destroy previous shader for this card (if still alive) so animation restarts fresh */
      if (active[key]) {
        destroyShader(active[key]);
        delete active[key];
      }
      if (shaderEl) {
        shaderEl.classList.remove(
          "is-leaving",
          "is-active",
          "is-settle",
          "is-fallback",
        );
        shaderEl.style.transform = "scale(0)";
        shaderEl.style.opacity = "0";
      }
      active[key] = createShader(card);
      /* R18: Cache rect on enter — no forced reflow in mousemove */
      if (inner) _rectCache[key] = inner.getBoundingClientRect();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (thisHover !== hoverToken || !card.matches(":hover")) return;

          if (shaderEl) {
            shaderEl.style.transform = "";
            shaderEl.style.opacity = "";
            shaderEl.classList.add("is-active");
          }

          setTimeout(function () {
            if (thisHover !== hoverToken || !card.matches(":hover")) return;
            if (shaderEl) shaderEl.classList.add("is-settle");
          }, 800);
        });
      });
      if (img)
        img.style.filter =
          "drop-shadow(0 0 14px " +
          color +
          "66) drop-shadow(0 0 28px " +
          color +
          "33)";
    });

    /* R18: RAF throttle + cached rect — zero forced reflows */
    card.addEventListener("mousemove", function (e) {
      if (ticking[key]) return;
      ticking[key] = true;
      requestAnimationFrame(function () {
        if (!inner) {
          ticking[key] = false;
          return;
        }
        var r = _rectCache[key];
        if (!r) {
          r = _rectCache[key] = inner.getBoundingClientRect();
        }
        inner.style.transform =
          "rotateX(" +
          -((e.clientY - r.top - r.height / 2) / r.height) * 5 +
          "deg) rotateY(" +
          ((e.clientX - r.left - r.width / 2) / r.width) * 5 +
          "deg)";
        if (glass) {
          glass.style.background =
            "radial-gradient(circle at " +
            (e.clientX - r.left) +
            "px " +
            (e.clientY - r.top) +
            "px,rgba(255,255,255,0.06) 0%,transparent 50%)";
          glass.style.opacity = "1";
        }
        ticking[key] = false;
      });
    });

    card.addEventListener("mouseleave", function () {
      hoverToken += 1;

      ticking[key] = false;
      if (inner) inner.style.transform = "rotateX(0) rotateY(0)";
      if (glass) glass.style.opacity = "0";
      if (img) img.style.filter = "none";
      if (shaderEl) {
        shaderEl.classList.remove("is-active", "is-settle", "is-fallback");
        shaderEl.classList.add("is-leaving");
      }
      leaveTimers[key] = setTimeout(function () {
        if (shaderEl) shaderEl.classList.remove("is-leaving", "is-fallback");
        if (active[key]) {
          destroyShader(active[key]);
          delete active[key];
        }
        leaveTimers[key] = null;
      }, 400);
    });
  });

  /* R20.13: Star-Injection wurde nach oben (vor mobile-exit return) verschoben — lief auf Mobile sonst nie */
})();
